import styled from 'styled-components';

export const NameSpan = styled.span`
  padding-right: 220px;
  display: inline-block;
  background: '#749a4a 0% 0% no-repeat padding-box';
  width: 32px;
`;
